import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { I18nextAsyncBackend } from './i18nextC1i18nBackend'
import { I18nextLanguageDetector, DEFAULT_LANGUAGE_CODE } from './i18nextLanguageDetector'

i18n
  .use(new I18nextAsyncBackend())
  .use(new I18nextLanguageDetector())
  .use(initReactI18next)
  .init({
    // debug: true,
    fallbackLng: DEFAULT_LANGUAGE_CODE,
    lowerCaseLng: true,
    nonExplicitWhitelist: true,
    ns: 'cone',
    defaultNS: 'cone',
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
